import numeral from "numeral";

const price = v => numeral(v).format("0,0");
const seconds = v => numeral(v / 1000).format("0.000") + " s";

function mk(value) {
    if (value >= 1000000)
        return Math.round(value / 1000000) + "M";
    else if (value >= 1000)
        return Math.round(value / 1000) + "K";
    else
        return Math.round(value);
}

export { price, mk, seconds };